import React, { useState, useEffect } from 'react';
import { campaignUtils } from '../utils/campaignUtils';

const StatusMessageBox = () => {
  const [message, setMessage] = useState('');
  const [isVisible, setIsVisible] = useState(false);

  const fetchStatus = async () => {
    console.log('Fetching system status message...');
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/auth/system_status', {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const data = await response.json();
        const newMessage = data.message || '';

        if (newMessage !== message) {
          setMessage(newMessage);
          setIsVisible(!!newMessage);
        }

        const campaign = data.campaign || null;
        if (campaign) {
          console.log('Current Campaign:', campaign);
          // Load campaigns and refresh UI when campaign is not null
          try {
            await campaignUtils.loadCampaignsAndRefresh();
            console.log('Campaigns reloaded and UI refreshed successfully');
          } catch (error) {
            console.error('Failed to reload campaigns:', error);
          }
        }
      }
    } catch (error) {
      console.error('Error fetching status:', error);
    }
  };

  useEffect(() => {
    fetchStatus();
    const interval = setInterval(fetchStatus, 2000);
    return () => clearInterval(interval);
  }, [message]);

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!isVisible || !message) {
    return null;
  }

  return (
    <div style={{
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      backgroundColor: 'white',
      color: 'black',
      padding: '10px 15px',
      borderRadius: '6px',
      fontSize: '14px',
      zIndex: 1000,
      maxWidth: '300px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      border: '1px solid #ddd'
    }}>
      <span style={{ marginRight: '10px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {message}
      </span>
      <button
        onClick={handleClose}
        style={{
          background: 'none',
          border: 'none',
          color: 'black',
          cursor: 'pointer',
          fontSize: '16px',
          padding: '0',
          marginLeft: '5px'
        }}
        title="Close"
      >
        ×
      </button>
    </div>
  );
};

export default StatusMessageBox;